
  import {Component, Vue} from "vue-property-decorator";
  import {IDashboard} from "@/modules/Dashboard/interfaces/dashboard.interface";
  import {IBook} from "@/interfaces/book.interface";
  import SelectParks from "@/components/SpecialFilters/SelectParks.vue";
  import {IAppState} from "@/interfaces/app-state.interface";

  @Component({
    components: {SelectParks}
  })
  export default class FilterDashboard extends Vue {

    parksNoGroupBook: IBook.BookName = IBook.BookName.parksOwners;
    bookName = IBook.BookName;

    get storeState(): IAppState { return this.$store.state; }
    get filters(): IDashboard.IFilters { return this.storeState.dashboard.filters; }
    get filterEmpty() { return !this.filters.parks.length && !this.filters.tSumType; }
    get books() { return this.storeState.book.books; }
    get usedBooks(): IBook.ParkBookItem[] { return this.$store.getters['book/parksBook']; }
    get displayParksFilter() { return this.usedBooks.length !== 1; }

    changeFilterItem(value, name) {
      this.$store.commit('dashboard/setFilterParam', { name, value });
    }

    async clearFilters() {
      this.changeFilterItem([], 'parks');
      this.changeFilterItem(1, 'tSumType');
      await this.onFilterClick();
    }

    async onFilterClick() {
      localStorage.setItem(IDashboard.LocalStorageKeys.FilterValues, JSON.stringify(this.filters));
      if (this.filters.parks.length === 1 && this.filters.parks[0] === null) {
        this.changeFilterItem([], 'parks');
      }
      await this.$store.dispatch('dashboard/getDashboard', { useFilter: true });
      this.$emit('reloadDashboards');
    }
  }
